
import { createContext, useState } from "react";
export const DataContext = createContext();

const DataProvider = ({ children }) => {

    const [html, setHtml] = useState(`




`);
    const [css, setCss] = useState(`




`);
    const [js, setJs] = useState(`




`);

    const [viewPosition, setViewPosition] = useState(false);
    const [width1, setWidth1] = useState(0);
    const [width2, setWidth2] = useState(0);
    const [width3, setWidth3] = useState(0);
    const [height1, setHeight1] = useState(0);
    const [height2, setHeight2] = useState(0);
    const [toggle1, setToggle1] = useState(null);
    const [toggle2, setToggle2] = useState(null);
    const [toggle3, setToggle3] = useState(null);


    return (
        <DataContext.Provider
            value={{
                html, setHtml, css, setCss, js, setJs, viewPosition, setViewPosition, width1, setWidth1, width2, setWidth2, width3, setWidth3, height1, setHeight1, height2, setHeight2,
                toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3,
            }}
        >
            {children}
        </DataContext.Provider>
    );
}

export default DataProvider;